var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-wishlist-list.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"dom-wishlist-list\">\n\n    ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productAddToWishList")),"wishlists") && env.getFilter("length").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productAddToWishList")),"wishlists")) > 0) {
output += "\n\n        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"ownerView")) {
output += "\n            ";
var t_1;
t_1 = "js-move-to-different-list";
frame.set("selectAction", t_1, true);
if(frame.topLevel) {
context.setVariable("selectAction", t_1);
}
if(frame.topLevel) {
context.addExport("selectAction", t_1);
}
output += "\n        ";
;
}
else {
output += "\n            ";
var t_2;
t_2 = "js-add-to-wishlist";
frame.set("selectAction", t_2, true);
if(frame.topLevel) {
context.setVariable("selectAction", t_2);
}
if(frame.topLevel) {
context.addExport("selectAction", t_2);
}
output += "\n        ";
;
}
output += "\n\n        <ul class=\"g-product-wishlist-list u-extra-small--hide c-form__select-styled js-product-add-links__ul\">\n\n            ";
frame = frame.push();
var t_5 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productAddToWishList")),"wishlists");
if(t_5) {var t_4 = t_5.length;
for(var t_3=0; t_3 < t_5.length; t_3++) {
var t_6 = t_5[t_3];
frame.set("thisWishlist", t_6);
frame.set("loop.index", t_3 + 1);
frame.set("loop.index0", t_3);
frame.set("loop.revindex", t_4 - t_3);
frame.set("loop.revindex0", t_4 - t_3 - 1);
frame.set("loop.first", t_3 === 0);
frame.set("loop.last", t_3 === t_4 - 1);
frame.set("loop.length", t_4);
output += "\n\n                ";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "wishlist")),"currentWishlist") || runtime.memberLookup((t_6),"id") != runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "wishlist")),"currentWishlist")) {
output += "\n\n                    <li class=\"c-form__select-styled__li\">\n\n                        <a\n                            href=\"#\"\n                            class=\"c-form__select-styled__a ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "selectAction"), env.opts.autoescape);
output += "\"\n                            data-wishlistId=\"";
output += runtime.suppressValue(runtime.memberLookup((t_6),"id"), env.opts.autoescape);
output += "\"\n                            data-wishlistname=\"";
output += runtime.suppressValue(runtime.memberLookup((t_6),"name"), env.opts.autoescape);
output += "\"\n                            data-qa-wishlist-name=\"";
output += runtime.suppressValue(runtime.memberLookup((t_6),"name"), env.opts.autoescape);
output += "\"\n                        >\n                            ";
output += runtime.suppressValue(runtime.memberLookup((t_6),"name"), env.opts.autoescape);
output += "\n                        </a>\n\n                    </li>";
;
}
else {
output += "<li class=\"c-form__select-styled__li\">\n\n                        <span class=\"c-form__select-styled__span\">\n                            ";
output += runtime.suppressValue(runtime.memberLookup((t_6),"name"), env.opts.autoescape);
output += "\n                        </span>\n\n                    </li>\n\n                ";
;
}
output += "\n\n            ";
;
}
}
frame = frame.pop();
output += "\n\n        </ul>\n\n    ";
;
}
output += "\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-wishlist-list.j2"] , dependencies)